module.exports = __webpack_public_path__ + "static/headerBg.ae17b3f0.svg";


//////////////////
// WEBPACK FOOTER
// /www/client/src/components/ServicesPricingPage/headerBg.svg
// module id = 833
// module chunks = 0